import { useEffect, useState } from 'react';
import { Animated } from 'react-native';
import { dots, messages } from '../enums/enums';

export const useLoadingAnimation = () => {
    const [dotCount, setDotCount] = useState(0);
    const [messageIndex, setMessageIndex] = useState(0);
    const fadeAnim = new Animated.Value(1);

    useEffect(() => {
        setDotCount(0);

        const dotInterval = setInterval(() => {
            setDotCount((prev) => (prev + 1) % 3);
        }, 1000);

        Animated.timing(fadeAnim, {
            toValue: 1,
            duration: 3000,
            useNativeDriver: true,
        }).start();

        const messageInterval = setInterval(() => {
            if (messageIndex < messages.length - 1) {
                setMessageIndex((prev) => (prev + 1) % messages.length);
            }
        }, 3000);

        return () => {
            clearInterval(dotInterval);
            clearInterval(messageInterval);
        };
    }, [messageIndex]);

    return {
        dotCount,
        messageIndex,
        fadeAnim,
        currentMessage: messages[messageIndex],
        currentDots: dots[dotCount]
    };
};